module.exports = __webpack_public_path__ + "static/media/anno-adam.471410e9.png";